import React, { useEffect, useState, useRef } from 'react';
import { Grid, Checkbox, Label, Input, Box, Flex, Button, Image, Text } from 'theme-ui';
import { useUserProfile } from './userProfileContext';
import { useFirebaseProfile } from './useFirebaseProfile';
import { Camera } from 'lucide-react';  // import the camera icon from lucide-react
import Toast from './Toast';

const UserProfilePage = () => {

    const { userProfile } = useUserProfile();  
    
    const { 
        profile, 
        loading, 
        error, 
        fetchCompanies,
    } = useFirebaseProfile();    
    
    const [localProfile, setLocalProfile] = useState({});

    useEffect(() => {
        if (profile) {
            setLocalProfile(profile);
        }
    }, [profile]);

    const fileInputRef = useRef(null);

    if (loading) {
        return <Text>Loading profile...</Text>;
    }

    if (!localProfile) {
        return <Text>No profile data available.</Text>;
    }
    

    return (
        <Box sx={{ width: '100%', p: 4, fontFamily: 'body', margin: 3 }}>
            <Flex sx={{ flexDirection: ['column', null, 'row'], flexWrap: 'wrap', justifyContent: 'space-between' }}>
                <Box sx={{ width: ['90%', null, '28%'], pr: [0, null, 4], mb: [4, null, 0] }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 4 }}>
                        <Box
                            sx={{
                                position: 'relative',
                                width: ['60%', '70%'],
                                paddingBottom: ['60%', '70%'],
                                borderRadius: '50%',
                                overflow: 'hidden',
                            }}
                        >
                            <Image
                                src={localProfile.photoURL || '/placeholder-image.jpg'}
                                alt="Profile Picture"
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </Box>
                    </Box>
                    <Text sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: 24 }}>
                        {localProfile.displayName || 'No Name Available'}
                    </Text>
                    <Text sx={{ textAlign: 'center', color: 'gray', mt: 2 }}>
                        {localProfile.occupation || 'No Occupation Available'}
                    </Text>
                    <Text sx={{ textAlign: 'center', mt: 2 }}>
                        Class Year: {localProfile.classYear || 'Unknown'}
                    </Text>
                </Box>

                <Box sx={{ width: ['100%', null, '68%'], pl: [0, null, 4] }}>
                    <Text sx={{ mb: 3 }}>
                        <strong>Bio: </strong>
                        {localProfile.bio || 'No bio available.'}
                    </Text>
                    <Text sx={{ mb: 3 }}>
                        <strong>Companies: </strong>
                        {localProfile.companies ? localProfile.companies.join(', ') : 'No companies available.'}
                    </Text>
                    <Text sx={{ mb: 3 }}>
                        <strong>Talk to me about: </strong>
                        {localProfile.topics ? localProfile.topics.join(', ') : 'No topics available.'}
                    </Text>
                    <Text sx={{ mb: 3 }}>
                        <strong>Interests: </strong>
                        {localProfile.interests ? localProfile.interests.join(', ') : 'No interests available.'}
                    </Text>
                </Box>
            </Flex>
        </Box>
    );
};

export default UserProfilePage;